function showFloatingSidebar(floatingSidebar, sidebar, sidebarFooter) {
    const floatingSidebarYpos = floatingSidebar.getBoundingClientRect().top + window.scrollY;
    const floatingSidebarBottomEdge = floatingSidebarYpos + floatingSidebar.getBoundingClientRect().height;
    const sidebarBottomEdge = sidebar.getBoundingClientRect().top + window.scrollY + sidebar.getBoundingClientRect().height;
    const sidebarFooterBottomEdge = sidebarFooter.getBoundingClientRect().top + window.scrollY + sidebarFooter.getBoundingClientRect().height;

    if (floatingSidebarYpos > sidebarFooterBottomEdge + 100) {
        floatingSidebar.classList.remove('sidebar__main--hidden');
    } else {
        floatingSidebar.classList.add('sidebar__main--hidden');
    }

    if (floatingSidebarBottomEdge >= sidebarBottomEdge) {
        floatingSidebar.classList.add('sidebar__main--fixPosition');
    } 

    if ((window.scrollY + floatingSidebar.getBoundingClientRect().height + 20) < sidebarBottomEdge) {
        floatingSidebar.classList.remove('sidebar__main--fixPosition');
    }
}

function init() {
    const sidebar = document.querySelector('.js_sidebar');
    const sidebarFooter = document.querySelector('.js_sidebar__footer');
    const floatingSidebar = document.querySelector('.js_sidebar__main--floating');

    if (sidebar && floatingSidebar && sidebarFooter) {
        showFloatingSidebar(floatingSidebar, sidebar, sidebarFooter);

        document.addEventListener('scroll', e => showFloatingSidebar(floatingSidebar, sidebar, sidebarFooter));
    }
}

$(document).ready(init);
